<div class="flex flex-col px-0 py-2">
  <div class="flex items-center gap-2">
    <mat-icon class="file-icon-size" [svgIcon]="fileIcon"></mat-icon>
    <span class="document-name font-semibold text-lg">{{ data.documentName }}</span>
  </div>
  <span *ngIf="data.pageNumbers" class="page-number mt-1 ms-6 text-md">
    <span class="page-label text-gray-500">Page: </span>
    <span class="page-value font-semibold text-gray-700">{{ data.pageNumbers }}</span>
  </span>
</div>

<mat-dialog-content class="pt-2">
  <div [innerHTML]="markedContent" class="content-body"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>
